import './scrollArea.scss';  
import ScrollArea from './ScrollArea.jsx';

export default ScrollArea;